var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide2Box2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 715,
    height: 710,
    viewBox: "0 0 715 710",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 6,
    width: 653,
    height: 621,
    fill: "white",
    stroke: "#946E4A",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8939 300.51C16.6172 285.707 20.9626 252.002 22.4199 237C23.6123 274.506 25.2816 351.117 22.4199 357.518C18.8429 365.52 3.05488 366.257 0.560226 349.517C-1.82447 333.515 3.73982 319.013 10.8939 300.51Z",
    fill: "#946E4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M700.475 63.5097C692.844 48.7074 687.05 15.0023 685.107 0C683.517 37.5057 681.291 114.117 685.107 120.518C689.876 128.52 710.927 129.257 714.253 112.517C717.433 96.5147 710.014 82.0125 700.475 63.5097Z",
    fill: "#946E4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M664 631.462C656.245 631.011 644.292 630.697 633.809 631.234L489.46 630.144C472.799 626.812 442.287 628.091 428.051 627C414.159 627.073 393.844 627.837 376.244 629.29L286.135 628.609C284.293 628.156 282.528 627.653 280.978 627C273.325 627.05 263.134 627.542 252.724 628.357L73 627C95.2565 629.975 141.935 635.925 150.597 635.925C161.424 635.925 169.545 642.056 169.545 652.435C169.545 661.806 163.68 671.177 181.275 671.177C195.711 671.177 192.553 660.914 192.553 652.435C192.553 645.296 198.418 641.28 206.539 635.925C211.342 632.757 232.449 629.944 252.724 628.357L286.135 628.609C292.693 630.221 300.239 631.189 302.633 635.925C305.34 641.279 304.889 651.543 304.889 658.683C304.889 665.823 311.205 674.747 321.581 674.747C331.957 674.747 341.871 670.183 340.529 658.683C339.176 647.081 334.628 642.822 340.529 635.925C343.04 632.989 358.218 630.778 376.244 629.29L489.46 630.144C495.504 631.353 499.725 633.169 500.685 635.925C505.197 648.866 485.347 676.086 483.542 688.581C481.737 701.075 488.053 710 506.099 710C524.145 710 530.461 696.007 530.461 688.581C530.461 679.21 508.355 642.172 516.024 635.925C523.694 629.677 574.673 631.462 582.343 635.925C590.012 640.387 574.222 656.966 574.222 667.161C574.222 676.086 583.245 685.457 599.035 684.565C614.825 683.672 620.69 678.317 620.69 667.161C620.69 656.005 607.156 643.064 612.569 635.925C614.711 633.101 623.557 631.76 633.809 631.234L664 631.462Z",
    fill: "#946E4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.717 693.055C186.299 689.905 182.221 682 177 682C171.779 682 167.701 689.905 166.283 693.055C164.843 694.745 164 696.793 164 699C164 704.799 169.82 709.5 177 709.5C184.18 709.5 190 704.799 190 699C190 696.793 189.157 694.745 187.717 693.055Z",
    fill: "#946E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2Box2);
export default __webpack_public_path__ + "static/media/slide2box2.21eddec15c03c5315a5ec23269f5fa1b.svg";
export { ForwardRef as ReactComponent };